import { avatarAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseStyle = definePartsStyle({
  container: defineStyle({
    bg: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'neutral.border-subtle',
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 'inherit',
    },
  }),
  label: defineStyle({
    color: 'neutral.fg-tertiary',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  }),
});

const sizes = {
  '3xs': definePartsStyle({
    container: defineStyle({
      width: '12px',
      height: '12px',
      borderRadius: 'sm',
      img: { borderRadius: 'sm' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  '2xs': definePartsStyle({
    container: defineStyle({
      width: '16px',
      height: '16px',
      borderRadius: 'sm',
      img: { borderRadius: 'sm' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  xs: definePartsStyle({
    container: defineStyle({
      width: '20px',
      height: '20px',
      borderRadius: 'sm-md',
      img: { borderRadius: 'sm-md' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  sm: definePartsStyle({
    container: defineStyle({
      width: '24px',
      height: '24px',
      borderRadius: 'sm-md',
      img: { borderRadius: 'sm-md' },
    }),
    label: defineStyle({ fontSize: 'xs' }),
  }),
  md: definePartsStyle({
    container: defineStyle({
      width: '36px',
      height: '36px',
      borderRadius: 'md',
      img: { borderRadius: 'md' },
    }),
    label: defineStyle({ fontSize: 'sm' }),
  }),
  lg: definePartsStyle({
    container: defineStyle({
      width: '40px',
      height: '40px',
      borderRadius: 'md',
      img: { borderRadius: 'md' },
    }),
    label: defineStyle({ fontSize: 'sm' }),
  }),
  xl: definePartsStyle({
    container: defineStyle({
      width: '48px',
      height: '48px',
      borderRadius: 'lg',
      img: { borderRadius: 'lg' },
    }),
    label: defineStyle({ fontSize: 'sm-md' }),
  }),
  '2xl': definePartsStyle({
    container: defineStyle({
      width: '56px',
      height: '56px',
      borderRadius: 'lg',
      img: { borderRadius: 'lg' },
    }),
    label: defineStyle({ fontSize: 'sm-md' }),
  }),
  '3xl': definePartsStyle({
    container: defineStyle({
      width: '64px',
      height: '64px',
      borderRadius: 'lg',
      img: { borderRadius: 'lg' },
    }),
    label: defineStyle({ fontSize: 'md' }),
  }),
};

const variants = {
  round: definePartsStyle({
    container: defineStyle({
      borderRadius: 'full',
      img: { borderRadius: 'full' },
    }),
  }),
};

export const styleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: 'xl',
  },
});
